import { Location, NgIf } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { LinqSocketsService } from '../../services';
import { Notification } from '../../shared/interfaces/notification';
import { DismissAllEvent, DismissEvent, NotificationClickEvent } from '../../shared/models/events';

@Component({
	selector: 'linq-sockets-notifications',
	templateUrl: './linq-sockets-notifications.component.html',
	styleUrls: ['./linq-sockets-notifications.component.scss'],
	imports: [NgIf],
	standalone: true,
})
export class LinqSocketsNotificationsComponent {
	isOpen = false;

	get notifications(): Notification[] {
		return this.linqSocketsService.notifications;
	}

	@Output('dismiss') dismiss = new EventEmitter<DismissEvent>();
	@Output('dismissAll') dismissAll = new EventEmitter<DismissAllEvent>();
	@Output('notificationClick')
	notificationClick = new EventEmitter<NotificationClickEvent>();

	constructor(readonly location: Location, readonly linqSocketsService: LinqSocketsService) {}

	toggleOpen(): void {
		this.isOpen = !this.isOpen;
	}

	dismissNotification(notification: Notification): void {
		const event = new DismissEvent(notification);

		this.dismiss.emit(event);

		if (event.isDefaultPrevented()) {
			return;
		}

		// remove the notification
		this.linqSocketsService.dismissNotification(notification);
	}

	dismissAllNotifications(): void {
		const event = new DismissAllEvent();

		this.dismissAll.emit(event);

		if (event.isDefaultPrevented()) {
			return;
		}

		// remove all notifications
		this.linqSocketsService.dismissAllNotifications();
	}

	clickNotification(notification: Notification, { target }: Event): void {
		const elem = (target as Element).closest('[data-linqsockets-notification]');

		const event = new NotificationClickEvent(notification, elem);

		this.notificationClick.emit(event);

		if (event.isDefaultPrevented() || !notification.Data?.Path) {
			return;
		}

		// change location if the notification has a .Data.Path
		this.location.go(notification.Data.Path);
	}
}
